<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 15L12.5 10L18 15" stroke="currentColor" />
  </svg>
</template>
